/**
 * PageScopeBanner — "this page does X, for Y go here" notice.
 *
 * Vanessa, 26 Sep 2026, on the Pipeline Tracker / Open Matters split:
 * "we will need to put a nice looking notice... so it's super clear for
 * the team". Small, shared, deliberately not fancy — used on both pages
 * so the boundary between them reads the same way from either side.
 */
import { Link } from "react-router-dom";
import { Info } from "lucide-react";

export default function PageScopeBanner({ text, linkTo, linkLabel, testId }) {
  return (
    <div
      className="flex items-center gap-2.5 mb-4 px-4 py-2.5 rounded-md border border-teal/30 bg-teal-dim/10 text-sm text-slate-300"
      data-testid={testId}
    >
      <Info className="w-4 h-4 text-teal shrink-0" />
      <span>{text}</span>
      <Link to={linkTo} className="text-teal hover:underline font-medium shrink-0 ml-auto">
        {linkLabel} →
      </Link>
    </div>
  );
}
